window.jPar = {
	state: {
		wdkDialog: {
			openedDialogList: [],
		},
	},
};

/* eslint-disable-next-line no-global-assign */ // TODO auf eslint hören und besser machen
deepMerge = function () {
	// I just copied and pasted from jQuery source and made just a small adaption to not prototpy the jQuery Object
	let options;
	let name;
	let src;
	let copy;
	let copyIsArray;
	let clone;
	let target = arguments[0] || {};
	let i = 1;
	const length = arguments.length;
	let deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;

		// Skip the boolean and the target
		target = arguments[i] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	// eslint-disable-next-line no-undef
	if (typeof target !== 'object' && !isFunction(target)) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if (i === length) {
		target = this;
		i--;
	}

	for (; i < length; i++) {
		// Only deal with non-null/undefined values
		if ((options = arguments[i]) !== null) {
			// Extend the base object
			// we don't want to check for if I guess, because we want to copy everything
			for (name in options) {
				if (Object.prototype.hasOwnProperty.call(options, name)) {
					copy = options[name];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if (name === '__proto__' || target === copy) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
						src = target[name];

						// Ensure proper type for the source value
						if (copyIsArray && !Array.isArray(src)) {
							clone = [];
						} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[name] = deepMerge(deep, clone, copy);

						// Don't bring in undefined values
					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};
